<template>
  <div>
    <div class="order-receipt-header">
      <h1>{{ $t('user.hello') }},  {{ userName }}</h1>
    </div>
    <div class="order-receipt-content profile-page">
      <v-overlay
        :opacity="0.5"
        :value="loading"
      >
        <v-progress-circular indeterminate size="64">
          {{ $t('loading') }}...
        </v-progress-circular>
      </v-overlay>

      <v-container>
        <v-text-field solo v-model="form.name" :label="$t('auth.name')" height="30px"></v-text-field>
        <v-text-field solo v-model="form.email" :label="$t('auth.email')" height="30px"></v-text-field>
        <v-text-field solo v-model="form.phone" :label="$t('auth.phone')" height="30px"></v-text-field>
        <v-text-field solo v-model="form.city" :label="$t('auth.city')" height="30px"></v-text-field>
        <vue-google-autocomplete
            ref="address"
            id="map"
            class="google-place-auto form-control"
            :placeholder="$t('home.saisie_address')"
            v-on:placechanged="getAddressData"
            country="ca">
        </vue-google-autocomplete>
        <!-- <v-text-field solo v-model="form.address" :label="$t('auth.address')" height="30px"></v-text-field> -->
      </v-container>
      <div class="text-center">
        <v-btn class="primary my-5" @click="handleSaveUser">{{ $t("auth.save") }}</v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters} from "vuex";
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: 'Home',
  data() {
    return {
      form: {
        id: '',
        email: '',
        city: '',
        phone: '',
        address: '',
        name: ''
      },
      loading: false
    };
  },
  /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
  components:{
    VueGoogleAutocomplete,
  },

  computed: {
    userName() {
      let user = JSON.parse(window.localStorage.getItem("userCPF"));
      return user.name; 
    }
  },
  methods: {
    ...mapActions(["updateUser"]),

    async handleSaveUser () {
        this.loading = true
        let user = this.updateUser(this.form);
        this.loading = false
        window.localStorage.setItem('userCPF', JSON.stringify(this.form));
        if(user) {
            window.location.reload()
        }
    },
    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getAddressData: function (addressData, placeResultData, id) {
        this.form.address = addressData;
    },
  },
  mounted () {
    this.form = JSON.parse(window.localStorage.getItem('userCPF'));
  }
}
</script>
<style lang="scss" scoped>
.hero {
  background-size: cover;
}

.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

.profile-text-field {
  border-color: black;
  height: 40px;
  margin-bottom: 10px;
}

.google-place-auto {
  /* width: 70%;
  height: 40px;
  border: 1px solid rgb(24, 24, 218);
  border-radius: 5px;
  margin-bottom: 5px;
  margin-right: 5px; */
  -webkit-appearance: none;
  background-color: #FFFFFF;
  background-image: none;
  margin-bottom: 10px;
  border: 1px solid rgb(214, 214, 214);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  color: #000;
  display: inline-block;
  font-size: inherit;
  height: 50px;
  line-height: 40px;
  outline: none;
  padding: 0 5px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2), 0 1px 3px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
}

.order-receipt {
  background-color: #f9fafb;

  &-header {
    padding-top: 20px;
    background-color: #ffffff;
    height: 150px;
    text-align: center;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-self: center;
    min-width: 100%;
    font-size: 26px;
    font-weight: bold;
  }

  &-content {
    padding: 10px;
    background-color: #f9fafb;
    min-height: 400px;
    text-align: center;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-self: center;
    padding: 0 25%;
  }
}
</style>